import type { AssetCategory, AssetType } from './types.js';

export const CATEGORY_MEMBERS: Readonly<Record<AssetCategory, readonly AssetType[]>> = {
  water: [
    'lotusPond',
    'reedMarsh',
    'willowPond',
    'whale',
    'fish',
    'fishSchool',
    'boat',
    'seagull',
    'dock',
    'waves',
    'kelp',
    'coral',
    'jellyfish',
    'turtle',
    'buoy',
    'sailboat',
    'lighthouse',
    'crab',
    'reeds',
    'canal',
    'pondLily',
    'frozenPond',
  ],
  shore: [
    'alpineRocks',
    'rock',
    'boulder',
    'flower',
    'bush',
    'driftwood',
    'sandcastle',
    'tidePools',
    'heron',
    'shellfish',
    'cattail',
    'frog',
    'lily',
    'snowCoveredRock',
    'parasol',
    'beachTowel',
    'sandcastleSummer',
    'surfboard',
  ],
  woodland: [
    'cedarGrove',
    'ancientOak',
    'wildflowerMeadow',
    'bambooThicket',
    'pine',
    'deciduous',
    'mushroom',
    'stump',
    'deer',
    'rabbit',
    'fox',
    'butterfly',
    'beehive',
    'wildflowerPatch',
    'tallGrass',
    'birch',
    'haybale',
    'willow',
    'palm',
    'bird',
    'owl',
    'squirrel',
    'moss',
    'fern',
    'deadTree',
    'log',
    'berryBush',
    'spider',
    'gardenTree',
    'snowPine',
    'snowDeciduous',
    'bareBush',
    'winterBird',
    'cherryBlossom',
    'cherryBlossomSmall',
    'nest',
    'birdhouse',
    'cherryBlossomFull',
    'cherryBlossomBranch',
    'peachBlossom',
    'robinBird',
    'butterflyGarden',
    'autumnMaple',
    'autumnOak',
    'autumnBirch',
    'autumnGinkgo',
    'acorn',
  ],
  farm: [
    'wheat',
    'fence',
    'scarecrow',
    'barn',
    'sheep',
    'cow',
    'chicken',
    'horse',
    'donkey',
    'goat',
    'ricePaddy',
    'silo',
    'pigpen',
    'trough',
    'haystack',
    'orchard',
    'appleTree',
    'oliveTree',
    'lemonTree',
    'orangeTree',
    'pearTree',
    'peachTree',
    'beeFarm',
    'pumpkin',
    'barnWinter',
    'sprout',
    'lamb',
    'gardenBed',
    'seedling',
    'sunflower',
    'watermelon',
    'cornStalk',
    'scarecrowAutumn',
    'harvestBasket',
    'pumpkinPatch',
    'hayMaze',
    'appleBasket',
    'riceTerrace',
    'kimchiGarden',
  ],
  village: [
    'tent',
    'hut',
    'house',
    'houseB',
    'church',
    'windmill',
    'well',
    'tavern',
    'bakery',
    'stable',
    'garden',
    'laundry',
    'doghouse',
    'shrine',
    'wagon',
    'watermill',
    'igloo',
    'houseWinter',
    'houseBWinter',
    'churchWinter',
    'hanok',
    'pavilion',
    'stoneWall',
    'onggi',
    'choga',
    'koreanWatermill',
    'hanokGate',
  ],
  town: [
    'market',
    'inn',
    'blacksmith',
    'castle',
    'tower',
    'bridge',
    'cathedral',
    'library',
    'clocktower',
    'statue',
    'park',
    'warehouse',
    'gatehouse',
    'manor',
    'fountain',
    'frozenFountain',
    'swimmingPool',
    'stoneBridge',
    'hanokEstate',
  ],
  decoration: [
    'cart',
    'barrel',
    'torch',
    'flag',
    'cobblePath',
    'smoke',
    'signpost',
    'lantern',
    'woodpile',
    'puddle',
    'campfire',
    'snowman',
    'snowdrift',
    'icicle',
    'sled',
    'firewood',
    'christmasTree',
    'winterLantern',
    'cherryPetals',
    'tulip',
    'tulipField',
    'crocus',
    'rainPuddle',
    'flowerBed',
    'wateringCan',
    'umbrella',
    'iceCreamCart',
    'hammock',
    'sprinkler',
    'lemonade',
    'fireflies',
    'fallenLeaves',
    'leafSwirl',
    'hotDrink',
    'autumnWreath',
    'rake',
    'jangseung',
    'sotdae',
  ],
};
